var urls = {
  local: "http://localhost:5000/v1/",
  staging: "https://stage.thesentinel.io/v1/",
  prod: "https://api.thesentinel.io/v1/",
  dev: "https://mqttnginx.thesentinel.io/v1/",
};
const baseurl = urls[process.env.REACT_APP_ENV.trim()];

export default baseurl;
